import React from 'react';
import { Row, Col, Alert, Button } from 'react-bootstrap';

import FieldGroup from './common/FieldGroup.jsx';

const CustomerEditComponent = ({
	// state
	customer,
	customerValidation,
	alertStyle,
	alertMessage,
	forInsert,
	// dispatch
	editItem,
	setValue
}) => (

		<div>
			<Row>
				<Col xs={2} sm={2} md={2}>
					<Button onClick={editItem} bsStyle="info">
						Submit
					    </Button>
				</Col>
				<Col xs={10} sm={10} md={10}>
					<Alert bsStyle={alertStyle}>
						{alertMessage}
					</Alert>
				</Col>
			</Row>
			<br />
			<Row>
				<Col xs={12} sm={12} md={12}>
					<FieldGroup
						id="customerId"
						type="text"
						label="客戶代號"
						value={customer.get('customerId')}
						disabled={!forInsert}
						placeholder=""
						required="true"
						onChange={(id, value) => {
							setValue(id, value);
						}}
						validation={customerValidation.get('customerId')}
					/>
					<FieldGroup
						id="customerName"
						type="text"
						label="客戶名稱"
						value={customer.get('customerName')}
						placeholder=""
						required="true"
						onChange={(id, value) => {
							setValue(id, value);
						}}
						validation={customerValidation.get('customerName')}
					/>
					<FieldGroup
						id="contact"
						type="text"
						label="聯絡人"
						value={customer.get('contact')}
						placeholder=""
						required="true"
						onChange={(id, value) => {
							setValue(id, value);
						}}
						validation={customerValidation.get('contact')}
					/>
					<FieldGroup
						id="phone"
						type="text"
						label="電話"
						value={customer.get('phone')}
						placeholder=""
						required="true"
						onChange={(id, value) => {
							setValue(id, value);
						}}
						validation={customerValidation.get('phone')}
					/>
					<FieldGroup
						id="fax"
						type="text"
						label="傳真"
						value={customer.get('fax')}
						placeholder=""
						onChange={(id, value) => {
							setValue(id, value);
						}}
						validation={customerValidation.get('fax')}
					/>
					<FieldGroup
						id="address"
						type="text"
						label="地址"
						value={customer.get('address')}
						placeholder=""
						required="true"
						onChange={(id, value) => {
							setValue(id, value);
						}}
						validation={customerValidation.get('address')}
					/>
					<FieldGroup
						id="shippingAddress"
						type="text"
						label="出貨地址"
						value={customer.get('shippingAddress')}
						placeholder=""
						required="true"
						onChange={(id, value) => {
							setValue(id, value);
						}}
						validation={customerValidation.get('shippingAddress')}
					/>
					<FieldGroup
						id="receiptAddress"
						type="text"
						label="發票地址"
						value={customer.get('receiptAddress')}
						placeholder=""
						required="true"
						onChange={(id, value) => {
							setValue(id, value);
						}}
						validation={customerValidation.get('receiptAddress')}
					/>
					<FieldGroup
						id="id"
						type="number"
						label="統一編號"
						value={customer.get('sId')}
						placeholder=""
						onChange={(id, value) => {
							setValue(id, value);
							setValue('sId', value);
						}}
						validation={customerValidation.get('sId')}
					/>
				</Col>
			</Row>
		</div>

	);

export default CustomerEditComponent;


// WEBPACK FOOTER //
// ./src/components/CustomerEditComponent.jsx